export default {
  ENABLED: 0,
  DISABLED: -1,
};
